import AdminRegisteredCompetitorsApp from "./AdminRegisteredCompetitorsApp.vue";
import { vueAppWithPinia } from "../Common/vueApp";

export const DEFAULT_SORT_FIELD = "lastName";
export const DEFAULT_SORT_DIRECTION = "asc";

export default vueAppWithPinia(AdminRegisteredCompetitorsApp);
